import { StaticRouter } from 'react-router'
import { downloadPdfConstants } from '../constants/actionTypes'

const initialState = {
  isDownloading: false,
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case downloadPdfConstants.STARTED_DOWNLOAD:
      return {
        ...state,
        isDownloading: true,
      }

    case downloadPdfConstants.FINISHED_DOWNLOAD:
      return {
        ...StaticRouter,
        isDownloading: false,
      }

    default:
      return state
  }
}
